import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina clases de Tailwind resolviendo conflictos.
 *
 * `clsx` decide qué clases se aplican; `twMerge` se queda con la última de cada
 * grupo (`px-2 px-4` → `px-4`). Sin esto, pasar `className` a un componente
 * compartido termina dependiendo del orden de las clases en el string.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
